import { EnviromentTyping } from "./enviroment-typings";

export const environment: EnviromentTyping = {
    production: true,
    apiUrl: {
        identity: "https://api-staging.one.on-n1.com/identity",
        orga: "https://api-staging.one.on-n1.com/orga",
        data: "https://api-staging.one.on-n1.com/data",
        tech: "https://api-staging.one.on-n1.com/tech",
      pageDefaultSize: 25,
      defaultTimeoutSec: 30,
      tokenExpireOffsetSec: 59
    },
    lang: {
      defaultLanguage: "de-DE",
      useBrowserLanguage: false
    },
    idle: {
      autoRefreshOnViewAfter: 1000 * 60 * 2,
      idleTime: 60 * 5
    },
    alert: {
      batteryStatusAlertLevel: 20
    },
    image: {
      formImageResizeMaxSize: 1366
    },
    interceptor: {
      additionalHttpApiClientInterceptorsIdentifier: "additionalHttpApiClientInterceptors",
      apiPageDefaultSizeIdentifier: "apiPageDefaultSize",
      apiDefaultTimeoutSecIdentifier: "apiDefaultTimeoutSec"
    }
  };
